/* unplugin-vue-components disabled */import script from "./AppRoot.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppRoot.vue?vue&type=script&setup=true&lang=ts"

import "./AppRoot.vue?vue&type=style&index=0&id=56fefe35&lang=scss"
import "./AppRoot.vue?vue&type=style&index=1&id=56fefe35&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.28_typescript@6.0.0-dev.20250807__webpack@5.105.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fefe35"]])

export default __exports__